import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import useHomeStore from "./ZustandStore/useHomeStore";

const ShortProductOne = ({ fourSalesCard, productLink }) => {
  const { handleAddToCart } = useHomeStore();

  const products = fourSalesCard.flatMap((item) => item.products);

  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
      <button
        type="button"
        onClick={onClick}
        className={` ${className} mt-8 slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-right" />
      </button>
    );
  }

  function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${className} mt-8 slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-left" />
      </button>
    );
  }

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1500,
    slidesToShow: 1, // Show 1 slide at a time
    slidesToScroll: 1, // Scroll 1 set of 4 products at a time
    initialSlide: 0,
    autoplay: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  // Function to chunk products into groups of 4
  const chunkedProducts = [];
  for (let i = 0; i < products.length; i += 4) {
    chunkedProducts.push(products.slice(i, i + 4));
  }

  return (
    <div className="short-product pt-30">
      <div className="container container-lg">
        <div className="row gy-4">
          {fourSalesCard.map((item, index) => (
            <div
              key={item.id}
              className="col-xxl-3 col-lg-4 col-md-6 col-sm-12"
            >
              <div className="p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <div className="p-16 bg-main-50 rounded-16 mb-32">
                  <Link
                    to={`/salespages/${item.slug || "default-category"}`}
                    className="position-relative mb-0 pb-16 d-inline-block text-black text-md"
                  >
                    {item.title}
                  </Link>
                </div>
                <div className="short-product-list arrow-style-two">
                  <Slider {...settings}>
                    {chunkedProducts.map((chunk, chunkIndex) => (
                      <div key={chunk.id}>
                        <div className="product-column">
                          {chunk.map((product) => (
                            <div
                              key={product.id}
                              className="flex-align gap-16 mb-40"
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr",
                              }}
                            >
                              <Link
                                to={`/product/${product.slug}`}
                                className="link"
                              >
                                <div className="flex-align gap-10">
                                  <div className="w-90 h-90 rounded-12 border border-gray-100 flex-shrink-0">
                                    <img
                                      style={{
                                        objectFit: "contain",
                                        maxHeight: "5rem",
                                        minWidth: "100%",
                                      }}
                                      src={product.image}
                                      alt={product.title}
                                    />
                                  </div>
                                  <div className="product-card__content mt-12">
                                    <div className="flex-between">
                                      <div className="flex-align gap-2">
                                        {/* Loop through 5 stars */}
                                        {(() => {
                                          const rating = products.averageRating; // Example rating
                                          const fullStars = Math.floor(rating); // Full stars
                                          const hasHalfStar = rating % 1 >= 0.5; // Check for half star
                                          const stars = [];

                                          // Push full stars
                                          for (let i = 0; i < fullStars; i++) {
                                            stars.push("full");
                                          }

                                          // If there's a half star
                                          if (hasHalfStar) {
                                            stars.push("half");
                                          }

                                          // Fill the remaining stars with empty ones
                                          while (stars.length < 5) {
                                            stars.push("empty");
                                          }

                                          return stars.map((star, index) => (
                                            <span
                                              key={index}
                                              className="text-10 --bs-warning fw-medium d-flex"
                                            >
                                              {/* Display full, half, or empty star */}
                                              <i
                                                className={`${
                                                  star === "empty"
                                                    ? "bi bi-star text-warning" // Empty star
                                                    : "bi bi-star-fill text-warning" // Full star with color
                                                } ${
                                                  star === "half"
                                                    ? "bi bi-star-half text-warning"
                                                    : ""
                                                }`}
                                              />
                                            </span>
                                          ));
                                        })()}
                                      </div>
                                      <span className="text-xs fw-bold text-gray-500">
                                        ({product.reviewCount || 3}k reviews)
                                      </span>
                                    </div>
                                    <h6 className="title text-lg fw-semibold mt-8 mb-8 link text-line-1">
                                      {product.title || "No Title"}
                                    </h6>
                                    <div className="product-card__price flex-align gap-8">
                                      <span className="text-heading text-md fw-semibold d-block">
                                        Rs.
                                        {product.offered &&
                                        !isNaN(product.offered)
                                          ? product.offered
                                          : ""}
                                      </span>
                                      <span className="text-xs text-muted d-block text-decoration-line-through">
                                        Rs.
                                        {product.selling &&
                                        !isNaN(product.selling)
                                          ? product.selling
                                          : ""}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShortProductOne;
